import { CarrierSubmission } from 'types';
import { CapitolaClient } from './base';

export default class CarrierSubmissionClient extends CapitolaClient<CarrierSubmission> {
  public get resourceName(): string {
    return 'carrier-submission';
  }
}
